// src/api/adminPackagesApi.js
import api from "./axios";

function buildQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    qs.set(k, String(v));
  });
  return qs.toString();
}

export const AdminPackagesAPI = {
  /**
   * params typiques:
   * { page:1, page_size:100, search:"", is_active:true/false }
   */
  async listPacks(params) {
    const q = buildQuery(params);
    const url = q ? `/admin/packages/packs?${q}` : "/admin/packages/packs";
    const res = await api.get(url);
    return res.data; // { items, total, page, page_size }
  },

  async getPack(packId) {
    const res = await api.get(`/admin/packages/packs/${packId}`);
    return res.data;
  },

  async createPack(payload) {
    const res = await api.post("/admin/packages/packs", payload);
    return res.data;
  },

  async updatePack(packId, payload) {
    const res = await api.put(`/admin/packages/packs/${packId}`, payload);
    return res.data;
  },

  async deletePack(packId) {
    const res = await api.delete(`/admin/packages/packs/${packId}`);
    return res.data;
  },

  /**
   * scope: { lab_ids: number[]|null, tags: string[]|null }
   */
  async saveScope(packId, scope) {
    const res = await api.post(`/admin/packages/packs/${packId}/scope`, scope);
    return res.data;
  },

  /**
   * duplication “simple”: crée un pack copy côté front.
   * Si tu ajoutes plus tard un endpoint backend /duplicate, on switch ici.
   */
  async duplicatePack(pack) {
    const payload = {
      code: `${pack.code}_COPY`,
      name: `${pack.name} (Copy)`,
      description: pack.description || null,
      total_minutes: Number(pack.total_minutes || 0),
      validity_days: pack.validity_days ?? null,
      is_active: !!pack.is_active,
    };
    const res = await api.post("/admin/packages/packs", payload);
    return res.data;
  },
};
